import getters from './getters';
import actions from './actions';
import mutations from './mutations';

export default {
  namespaced: true,
  state: {
    orders: [],
    order: {},
    new_order: {},
    pagination: {},
    validate_form: {},
    orderedItemsTotal: {}
  },
  actions,
  mutations,
  getters,
};
